import React, { useContext, useEffect, useRef, useState, useLayoutEffect } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { timeDiff, formatPrice } from "../../utils/Common";
import Pagination from "../../utils/pagination"; // Adjust the path accordingly
import { AppContext } from "../../context/context.js";
import DatePicker from "react-datepicker";
import ContentLayout from "../../layout/ContentLayout";
import { get, post } from "../../services/apiService";
import { useNavigate } from "react-router-dom";
import CustomerListItem from "../../components/Invoice/CustomerListItem.js";
import { useFlashMessage } from "../../context/FlashMessageContext";
import { BiPlus } from "react-icons/bi";
import { Modal } from "../../utils/Modal";
import BlogList from "./BlogList.js";
import Swal from "sweetalert2";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const Blog = () => {
  const token = localStorage.getItem("token");
  const {
    getFlashMessageStyle,
    setSuccessFlashMessage,
    flashMessage,
    setErrorFlashMessage,
  } = useFlashMessage();

  const [loading, setLoading] = useState(false);
  const loadingCallback = (loading) => {
    setLoading(loading);
  };

  const [blogList, setBlogList] = useState([]);
  const [showNewBlogModal, setShowNewBlogModal] = useState(false);
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();

  const getBlogList = (page, searchKeyword) => {
    loadingCallback(true);
    get(`latest-blog-list`, token)
      .then((response) => {
        loadingCallback(false);
        if (response.success) {
          //console.log("Blog list", response.data);
          setBlogList(response.data);
        }
      })
      .catch((error) => {
        loadingCallback(false);
        console.log(error);
        localStorage.clear();
        localStorage.setItem("token", false);
        // Clear session and local storage
        localStorage.setItem("isPinVerify", false);

        navigate("/login");
      });
  };

  const handleCreateClick = () => {
    /*    if (isCreateActive) { */
         // Show modal if creation is allowed
         setShowNewBlogModal((val) => !val);
   /*     } else {
         // Show warning if creation is not allowed
         Swal.fire({
           icon: "warning",
           title: "Permission Denied",
           text: "You do not have permission for this action.",
         });
       } */
     };

         const notify = (msg, type) => {
           if (type == "success") {
             toast.success(msg, {
               position: "top-right",
               autoClose: 3000,
               hideProgressBar: false,
               closeOnClick: true,
               pauseOnHover: true,
               draggable: true,
               progress: undefined,
               theme: "light",
             });
           }
           if (type == "error") {
             toast.error(msg, {
               position: "top-right",
               autoClose: 3000,
               hideProgressBar: false,
               closeOnClick: true,
               pauseOnHover: true,
               draggable: true,
               progress: undefined,
               theme: "light",
             });
           }
         };


  const [refetch, setRefetch] = useState(false)
  useEffect(() => {
    /* if ((isViewActive && hasPermission) || !localStorage.getItem("employee")) { */
      getBlogList();
    /* } */
  }, []);

  return (
    <>
      <ContentLayout>
        <div className="main-content recentTableContent">
        <ToastContainer />
          <div className="flex flex-col w-full">
            <div className="flex flex-col md:flex-row justify-between mb-4">
              <div>
                <h1 className="text-[#000232] text-[22px] font-[600] font-lato mb-2">
                  Blog List
                </h1>
              </div>
              <div className="flex gap-2 justify-center">
                <div className="flex relative  w-[95%]">
                  <input
                    autoFocus
                    type="text"
                    className="bg-[#E5EDFF] rounded-[11px] w-[100%] pt-[14px] pr-[28px] pl-[35px] pb-[12px] placeholder:text-[#91919F] placeholder:text-[14px] focus:outline-none"
                    placeholder="Search Category"
                    // onChange={(e) => {
                    //   setSearchFilter({...searchFilter, keyword: e.target.value})
                    // }}
                  />

                  <div className="absolute top-[37%] left-[10px]">
                    <AiOutlineSearch className="text-base text-[#407BFF] font-bold"></AiOutlineSearch>
                  </div>
                </div>
                <label
                  onClick={handleCreateClick}
                  htmlFor="add_expense_modal"
                  className={`cursor-pointer bg-[#407BFF] rounded-[5px] text-[#FFF] text-sm font-nunito font-bold py-2.5 pl-[22px] pr-[24px] flex items-center gap-2 `} //${!isCreateActive && "opacity-50 cursor-not-allowed"} Apply disabled styles
                  //style={{ pointerEvents: isCreateActive ? "auto" : "none" }}
                >
                  <BiPlus className="text-xl"></BiPlus>
                </label>
              </div>
            </div>
            {flashMessage && (
              <div
                className={`font-bold text-2xl text-center font-nunito mb-3 ${getFlashMessageStyle(
                  flashMessage.type
                )}`}
              >
                {flashMessage.text}
              </div>
            )}
            {loading && (
              <div className="custom-loader-logo">
                {/* <BeatLoader color={"#123abc"} size={20} /> */}
                <img
                  className=""
                  src={`${process.env.REACT_APP_ROOT_URL + "/smallLogo.png"}`}
                  alt="logo"
                />
              </div>
            )}
            {/* {(isViewActive && hasPermission) || !localStorage.getItem("employee") ? ( */}
            <>
              <div className="grid grid-cols-5  gap-2 md:gap-5 text-center font-nunito font-bold text-[14px] text-[#000232] border-b-[1px] border-solid border-[#E7EBF4]">
                {/* <div className="py-[8px]">ID</div> */}
                <div className="text-left py-[8px] hidden sm:block">
                 Title
                </div>
                <div className="py-[8px] text-center hidden sm:block">Status</div>
                <div className="py-[8px] text-center hidden sm:block">
                  Created At
                </div>
                <div className="py-[8px] text-center">Updated At</div>
                <div className="py-[8px] text-right">Action</div>
              </div>
              {/* {(isViewActive && hasPermission) || !localStorage.getItem("employee") ? ( */}
              <div className="max-h-[70vh] overflow-y-auto">
                { blogList ? blogList.map((item, index) => (
                      <BlogList
                        key={index}
                        index={index}
                        //loadingCallback={loadingCallback}
                        navigate={navigate}
                        blogs={item}
                        getBlogList={getBlogList}
                        //loading={loading}
                        //showModalBeforeDelete = {showModalBeforeDelete}
                        //setShowNewExpenseModal={setShowNewExpenseModal}
                      />
                      )): null
                    }

                <div className="hrtable"></div>
              </div>
            </>
            {/* ) : null} */}
          </div>
        </div>

        {showNewBlogModal ? (
          <Modal
          loadingCallback={loadingCallback}
          //navigate={navigate}
          isOpen={showNewBlogModal}
          setOpen={setShowNewBlogModal}
          title="Create Blog"
          formId="add_blog_modal"
          type="addBlogModal"
          selectType="expense"
          //refetch={()=>setRefetch(val=>!val)}
          formData={formData}
          setFormData={setFormData}
          getBlogList={getBlogList}
          //setWarningMessage={setWarningMessage}
          />
        ) : (
          ""
        )}
      </ContentLayout>
    </>
  );
};

export default Blog;
